<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">提现记录</div>
    </div>

    <div class="detail_box">
      <!-- 拒绝记录部分 -->
      <div v-if="refusedList.length > 0" class="refused-section">
        <h3>被拒绝的提现申请</h3>
        <table>
          <tr>
            <th style="width: 20%">金额</th>
            <th style="width: 40%">拒绝理由</th>
            <th>申请时间</th>
          </tr>
          <tr v-for="item in refusedList" :key="item.id" class="refused-row">
            <td>{{ item.money }}</td>
            <td>{{ item.refuse_reason || '无理由' }}</td>
            <td>{{ item.time }}</td>
          </tr>
        </table>
      </div>

      <!-- 资金流水部分 -->
      <h3 v-if="data.length > 0">资金流水记录</h3>
      <van-empty v-if="listShow && refusedList.length === 0" :description="$t('item.noData')" />

      <table v-if="data.length > 0">
        <tr>
          <th style="width: 20%">类型</th>
          <th>金额</th>
          <th>时间</th>
        </tr>
        <tr v-for="item in data" :key="item.id">
          <td>{{ item.type == 1 ? '收入' : '支出' }}</td>
          <td>{{ item.money }}</td>
          <td>{{ item.time }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from '../../utils/fetch'
import { Empty } from 'vant'

Vue.use(Empty)

export default {
  name: 'WithdrawRecord',
  data() {
    return {
      lang: this.$i18n.locale || 'zh_cn',
      data: [],
      refusedList: [], // 新增：拒绝记录
      list: {},
      account: 0,
      option: [],
      listShow: false,
      funds: 0,
      userName: '',
    }
  },
  created() {
    this.$parent.footer('user', false)
  },
  mounted() {
    document.getElementById('app').style.background =
      'linear-gradient(to bottom, #5674d3, #a8b6e5)'
    document.getElementById('app').style.marginBottom = '0px'
    
    Fetch('/user/funds', {
      reason_id: 2,
    }).then((r) => {
      this.option.push({
        text: this.$t('moneybag.types'),
        value: 0,
      })

      this.showError(r.data.list.length)
      this.data = r.data.list
      this.funds = r.data.money
      this.userName = r.data.username
      this.refusedList = r.data.refused_list || [] // 获取拒绝记录
    })
  },
  methods: {
    showError(len) {
      len == 0 ? (this.listShow = true) : (this.listShow = false)
    },
  },
}
</script>

<style lang="less" scoped>
.red_top_bg {
  background: linear-gradient(to left, #5674d3, #a8b6e5);
  height: 50px;
}

.detail_box {
  padding: 15px;
  background: rgba(255, 255, 255, 1);
  
  .refused-section {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #ff6b6b;
    
    h3 {
      color: #ff6b6b;
      font-size: 16px;
      margin-bottom: 10px;
      padding-left: 5px;
    }
    
    .refused-row {
      background-color: #fff5f5;
      
      td {
        color: #ff6b6b;
      }
    }
  }
  
  h3 {
    font-size: 16px;
    color: #333;
    margin: 15px 0 10px 5px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    
    tr {
      height: 50px;
      
      th {
        border: 1px solid #ebeef5;
        color: rgb(144, 147, 153);
        background-color: #f8f9fa;
        font-weight: 600;
      }
      
      td {
        line-height: 20px;
        border: 1px solid #ebeef5;
        text-align: center;
        color: rgb(96, 98, 102);
        padding: 5px;
      }
    }
  }
}
</style>